<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-snackbar v-model="showSnackBar" color="#63028F" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{msg}}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color:white;">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex px-4 xs12 md10>
        <v-card tile flat>
          <v-layout px-2 pt-4 wrap>
            <v-flex text-left>
              <span style="font-family:opensansextrabold;font-size:24px;color:#63028F;">&#9675;</span>
              <span
                style="font-family:opensansextrabold;font-size:20px;color:#060606"
              >&nbsp;Account Information</span>
            </v-flex>
            <v-flex text-right>
              <v-btn
                small
                dark
                depressed
                outlined
                :ripple="false"
                color="#CFCFCF"
                v-if="!enableEdit"
                @click="enableEdit=!enableEdit"
              >
                <span>
                  <v-img src="./../../assets/icons/pencil.svg" height="20px" contain></v-img>
                </span>
                <span
                  style="font-family:opensansregular;font-size:12px;color:#000"
                  class="px-2 text-capitalize"
                >Edit</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout v-if="!enableEdit" px-6 py-4 wrap>
            <v-flex xs6>
              <v-layout wrap>
                <v-flex xs12 text-left pt-2>
                  <span style="font-family:opensansregular;font-size:13px;color:#8D8D8D;">Name</span>
                </v-flex>
                <v-flex xs12 text-left>
                  <span
                    style="font-family:opensansbold;font-size:16px;color:#000000;"
                    v-if="userData.fullname"
                  >{{userData.fullname}}</span>
                  <span style="font-family:opensansbold;font-size:16px;color:#000000;" v-else>-</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap>
                <v-flex xs12 text-left pt-2>
                  <span style="font-family:opensansregular;font-size:13px;color:#8D8D8D;">Username</span>
                </v-flex>
                <v-flex xs12 text-left>
                  <span
                    style="font-family:opensansbold;font-size:16px;color:#000000;"
                    v-if="userData.username"
                  >{{userData.username}}</span>
                  <span style="font-family:opensansbold;font-size:16px;color:#000000;" v-else>-</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap>
                <v-flex xs12 text-left pt-2>
                  <span
                    style="font-family:opensansregular;font-size:13px;color:#8D8D8D;"
                  >Mobile Number</span>
                </v-flex>
                <v-flex xs12 text-left>
                  <span
                    style="font-family:opensansbold;font-size:16px;color:#000000;"
                    v-if="userData.phone"
                  >+91 {{userData.phone}}</span>
                  <span style="font-family:opensansbold;font-size:16px;color:#000000;" v-else>-</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap>
                <v-flex xs12 text-left pt-2>
                  <span style="font-family:opensansregular;font-size:13px;color:#8D8D8D;">Email Id</span>
                </v-flex>
                <v-flex xs12 text-left>
                  <span
                    style="font-family:opensansbold;font-size:16px;color:#000000;"
                    v-if="userData.email"
                  >{{userData.email}}</span>
                  <span style="font-family:opensansbold;font-size:16px;color:#000000;" v-else>-</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap>
                <v-flex xs12 text-left pt-2>
                  <span style="font-family:opensansregular;font-size:13px;color:#8D8D8D;">Gender</span>
                </v-flex>
                <v-flex xs12 text-left>
                  <span
                    style="font-family:opensansbold;font-size:16px;color:#000000;"
                    v-if="userData.gender"
                  >Male</span>
                  <span style="font-family:opensansbold;font-size:16px;color:#000000;" v-else>-</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap>
                <v-flex xs12 text-left pt-2>
                  <span
                    style="font-family:opensansregular;font-size:13px;color:#8D8D8D;"
                  >Date of Birth</span>
                </v-flex>
                <v-flex xs12 text-left>
                  <span
                    style="font-family:opensansbold;font-size:16px;color:#000000;"
                    v-if="userData.dob"
                  >{{userData.dob}}</span>
                  <span style="font-family:opensansbold;font-size:16px;color:#000000;" v-else>-</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap>
                <v-flex xs12 text-left pt-2>
                  <span style="font-family:opensansregular;font-size:13px;color:#8D8D8D;">Address</span>
                </v-flex>
                <v-flex xs12 text-left>
                  <span
                    style="font-family:opensansbold;font-size:16px;color:#000000;"
                    v-if="userData.streetAddress"
                  >{{userData.streetAddress}}</span>
                  <span style="font-family:opensansbold;font-size:16px;color:#000000;" v-else>-</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap>
                <v-flex xs12 text-left pt-2>
                  <span style="font-family:opensansregular;font-size:13px;color:#8D8D8D;">City</span>
                </v-flex>
                <v-flex xs12 text-left>
                  <span
                    style="font-family:opensansbold;font-size:16px;color:#000000;"
                    v-if="userData.city"
                  >{{userData.city}}</span>
                  <span style="font-family:opensansbold;font-size:16px;color:#000000;" v-else>-</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap>
                <v-flex xs12 text-left pt-2>
                  <span style="font-family:opensansregular;font-size:13px;color:#8D8D8D;">State</span>
                </v-flex>
                <v-flex xs12 text-left>
                  <span
                    style="font-family:opensansbold;font-size:16px;color:#000000;"
                    v-if="userData.state"
                  >{{userData.state}}</span>
                  <span style="font-family:opensansbold;font-size:16px;color:#000000;" v-else>-</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap>
                <v-flex xs12 text-left pt-2>
                  <span style="font-family:opensansregular;font-size:13px;color:#8D8D8D;">Pincode</span>
                </v-flex>
                <v-flex xs12 text-left>
                  <span
                    style="font-family:opensansbold;font-size:16px;color:#000000;"
                    v-if="userData.pincode"
                  >{{userData.pincode}}</span>
                  <span style="font-family:opensansbold;font-size:16px;color:#000000;" v-else>-</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout v-if="enableEdit" px-6 py-4 wrap justify-space-between>
            <v-flex xs5>
              <v-text-field label="Name" color="#63028F" v-model="user.fullname"></v-text-field>
            </v-flex>
            <v-flex xs5>
              <v-text-field label="Username" color="#63028F" v-model="user.username"></v-text-field>
            </v-flex>
            <v-flex xs5>
              <v-text-field label="Mobile Number" color="#63028F" v-model="user.phone"></v-text-field>
            </v-flex>
            <v-flex xs5>
              <v-text-field label="Email Id" color="#63028F" v-model="user.email"></v-text-field>
            </v-flex>
            <v-flex xs5>
              <v-select
                :items="genders"
                label="Gender"
                color="#63028F"
                item-color="#63028F"
                v-model="user.gender"
              ></v-select>
            </v-flex>
            <v-flex xs5>
              <!-- <v-text-field label="Date of Birth" color="#63028F" v-model="user.dob"></v-text-field> -->

              <v-menu
                ref="dOBPicker"
                v-model="dOBPicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="user.dob"
                    color="#63028F"
                    label="Date of Birth"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  color="#63028F"
                  v-model="user.dob"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1950-01-01"
                  @change="saveDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs5>
              <v-textarea
                :auto-grow="true"
                rows="1"
                label="Address"
                color="#63028F"
                v-model="user.streetAddress"
              ></v-textarea>
            </v-flex>
            <v-flex xs5>
              <v-text-field label="City" color="#63028F" v-model="user.city"></v-text-field>
            </v-flex>
            <v-flex xs5>
              <v-text-field label="District" color="#63028F" v-model="user.district"></v-text-field>
            </v-flex>
            <v-flex xs5>
              <v-text-field label="State" color="#63028F" v-model="user.state"></v-text-field>
            </v-flex>
            <v-flex xs5>
              <v-text-field label="Pincode" color="#63028F" v-model="user.pincode"></v-text-field>
            </v-flex>
            <v-flex xs5>
              <v-text-field label="Country" color="#63028F" v-model="user.country"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-layout wrap justify-end>
                <v-flex xs2 text-right>
                  <v-btn
                    small
                    block
                    dark
                    depressed
                    :ripple="false"
                    color="#63028F"
                    v-if="enableEdit"
                    @click="updateProfile"
                  >
                    <span
                      style="font-family:opensanssemibold;font-size:12px;"
                      class="text-capitalize"
                    >Save</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
// import store from "./../../store";
export default {
  props: ["userData"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      timeout: 5000,
      showSnackBar: false,
      msg: null,
      enableEdit: false,
      // userData: {},
      genders: ["Male", "Female", "Others"],
      user: {
        fullname: null,
        username: null,
        phone: null,
        email: null,
        gender: "Male",
        dob: null,
        streetAddress: null,
        city: null,
        district: null,
        state: null,
        pincode: null,
        country: null,
        id: null,
      },
      dOBPicker: false,
    };
  },
  beforeMount() {
    this.user = this.userData;
  },
  watch: {
    dOBPicker(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  methods: {
    saveDate(date) {
      this.$refs.dOBPicker.save(date);
    },
    updateProfile() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/Edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.enableEdit = false;
            this.$emit("stepper", {
              updateData: true,
            });
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>